export default "__VITE_ASSET__EKr3Qzh4__"